module.exports = __webpack_public_path__ + "static/media/Mask_Group_1.f112c368.png";